import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, Form, Input, PasswordInput, Select } from "../../styles";
import AuthWrapper from "../../layout/AuthWrapper";
import { ICON_EYE_FILL, ICON_EYE_SLASH_FILL } from "../../utils/icons";
import { form } from "../../assets";
import AuthApi from "../../api/authAxios";

function UserReg() {

  const [sending, setsending] = useState(false);
  let navigate = useNavigate();

  // Form Fields
  let locationData = useLocation();

  const [formField, setformField] = useState({
    email: locationData?.state?.email || '',
  }); function handleChange(e) {
    setformField((inputs) => ({
      ...inputs,
      [e.target.name]: e.target.value,
    }));
  }
  // Form Fields

  // Submit Function
  function submitFn(e) {
    e.preventDefault();
    if (formField.pword !== formField.cpword) {
      toast.warn("Confirm password does not match password");
      return;
    }
    if (
      formField?.email &&
      formField.fname &&
      formField.lname &&
      formField.gender &&
      formField.pword &&
      formField.cpword &&
      formField.username &&
      formField.phone
    ) {
      setsending(true);
      const data = {

        mail: formField?.email,
        fname: formField.fname,
        lname: formField.lname,
        phone: formField.phone,
        gender: formField.gender,
        pword: formField.pword,
        cpword: formField.cpword,
        username: formField.username,
        // ref: formField?.ref,
        // phoneCountryCode: selectedCountry?.phoneCountryCode,
        // country: selectedCountry?.value,
      };
      AuthApi.post(`/completeRegister`, data)
        .then((res) => {
          if (res.success === false) {
            if (res.message === "Your email needs to be verified before you proceed.") {
              toast.warn(res.message);
              setTimeout(() => {
                navigate('/register');
              }, 10);
              return;
            }
            toast.warn(res.message);
            setsending(false);
          } else {
            setsending(false);
            navigate(
              "/register-success",
              { state: formField?.email }
            );
            setTimeout(() => {
              toast.success(`${ res.message }, Check your email to activate your account.`);
            }, 10);
          }
        })
        .catch((error) => {
          setsending(false);
        });
    } else {
      setsending(false);
      toast.warn("Empty Fields!");
    }

  }

  // Submit Function


  // Password Show Function 
  const [eye, seteye] = useState(true);
  const [eye1, seteye1] = useState(true);


  return (
    <>

      <AuthWrapper
        title='Get Started'
        subTitle='Open a RENI account today to begin your journey.'
        img={form}
      >
        <Form onSubmit={(e) => submitFn(e)} >
          <div className="row justify-content-center text-left">
            <div className="col-md-6 ">
              <label className="mb-0"> First Name:</label>
              <Input
                type="text"
                name="fname"
                placeholder="First Name"
                onChange={handleChange}
                required
                value={formField.fname}
              />
            </div>
            <div className="col-md-6 ">
              <label className="mb-0"> Last Name:</label>
              <Input
                type="text"
                name="lname"
                placeholder="Last Name"
                onChange={handleChange}
                required
                value={formField.lname}
              />
            </div>
            <div className="col-md-6 ">
              <label className="mb-0"> Username:</label>
              <Input
                type="text"
                name="username"
                placeholder="username"
                onChange={handleChange}
                required
                value={formField.username}
              />
            </div>

            <div className="col-md-12 ">
              <label className="mb-0"> Email:</label>
              <Input
                type="email"
                name="email"
                placeholder="example@example.com"
                onChange={handleChange}
                autoComplete="false"
                required
                value={formField.email}
              />
            </div>
            <div className="col-md-12 ">
              <label className="mb-0"> Phone Number:</label>
              <Input
                type="number"
                name="phone"
                placeholder="080123456789"
                onChange={handleChange}
                required
                value={formField.number}
              />
            </div>
            <div className="col-md-6 ">
              <label className="mb-0"> Gender:</label>
              <Select
                type="text"
                name="gender"
                className=""
                onChange={handleChange}
                required
                value={formField.gender}
              >
                <option value="">--Select a gender--</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </Select>
            </div>
            <div className="col-md-12 ">
              <label className="mb-0"> Password:</label>
              <div className="input-group">
                <PasswordInput
                  type={eye ? 'password' : 'text'}
                  name="pword"
                  placeholder="Password"
                  onChange={handleChange}
                  required
                  value={formField.pword}
                  minLength="8"
                />
                <span
                  className="toggle-eye"
                  onClick={() => seteye(!eye)}
                >
                  {eye ? ICON_EYE_FILL : ICON_EYE_SLASH_FILL}

                </span>
              </div>
            </div>
            <div className="col-md-12 ">
              <label className="mb-0"> Comfirm Password:</label>
              <div className="input-group">
                <PasswordInput
                  type={eye1 ? 'password' : 'text'}
                  name="cpword"
                  placeholder="Password"
                  onChange={handleChange}
                  required
                  value={formField.cpword}
                  minLength="8"
                />

                <span
                  className="toggle-eye"
                  onClick={() => seteye1(!eye1)}
                >
                  {eye1 ? ICON_EYE_FILL : ICON_EYE_SLASH_FILL}
                </span>
              </div>
            </div>

            <div className="col-md-12 mx-auto text-center">
              <Button
                pry
                type="submit"
                disabled={sending}
                className="btn m-0 w-100"  >
                {sending ? 'loading...' : "Create Free Account"}
              </Button>

              <div className="text-center mt-4">
                <small>
                  {" "}
                  By clicking the button above, you agree to our{" "}
                  <span className="pry-text">
                    <Link>Terms & Conditions</Link>
                  </span>{" "}
                  and{" "}
                  <span className="pry-text">
                    <Link>Privacy Policy </Link>
                  </span>{" "}
                  .
                </small>
                <hr className="m-2" />

                <small>
                  Already have an account?
                  <span className="pry-text">
                    <Link to="/login"> Login</Link>
                  </span>
                  .
                </small>
              </div>
            </div>
          </div>
        </Form>
      </AuthWrapper>

    </>
  );
}

export default UserReg;
